import { createSlice, PayloadAction } from '@reduxjs/toolkit';


interface BudgetState {
  showTooltip: {[key:string]:boolean};
  type: string|null;

}

const initialState: BudgetState = {	
  showTooltip:{editBudget:true, sampleList:true},
  type: null,
} as BudgetState;


const budgetSlice = createSlice({
  name: 'budget',
  initialState,
  reducers: {
    setShowTooltip(state, action: PayloadAction<{[key:string]:boolean}>){
      state.showTooltip = {...action.payload};
    },
    setBudgetType(state, action: PayloadAction<string|null>){
      state.type = action.payload;
    },
  },
});

export const { setShowTooltip, setBudgetType } = budgetSlice.actions;
export default budgetSlice.reducer;